'use client';

import Image from 'next/image';
import Link from 'next/link';

import { SignedIn, SignedOut } from '@daveyplate/better-auth-ui';
import { CircleGauge, Menu, X } from 'lucide-react';

import { PublicNavigationMenu } from '@/components/navigation-menu';
import { Button } from '@/components/ui/button';
import { SidebarTrigger } from '@/components/ui/sidebar';

export function Header() {
  return (
    <header className="bg-background/95 border-accent fixed z-10 flex w-full items-center justify-between gap-4 border-b px-4 py-2 lg:gap-8">
      <Link href="/">
        <Image
          src="/statusly-logo.svg"
          width={124}
          height={43}
          alt="Statusly logo"
          className="transition-all group-data-[state=collapsed]:w-0"
        />
      </Link>
      <div className="flex flex-1 items-center justify-end md:justify-between">
        <div className="max-md:hidden">
          <PublicNavigationMenu />
        </div>
        <div className="flex items-center gap-3">
          <SignedIn>
            <Button size="sm" asChild>
              <a href="/dashboard">
                Dashboard <CircleGauge />
              </a>
            </Button>
          </SignedIn>
          <SignedOut>
            <Button size="sm" variant="outline" asChild>
              <Link href="/auth/sign-in">Sign In</Link>
            </Button>
            <Button size="sm" asChild>
              <Link href="/auth/sign-up">Sign Up</Link>
            </Button>
          </SignedOut>
        </div>
      </div>
      <SidebarTrigger className="md:hidden" IconExpand={Menu} IconCollapse={Menu} />
    </header>
  );
}
